import React, { useMemo } from 'react'
import classNames from 'classnames'

import style from './index.scss'
import Item from './jenga-item'

const MAX_ITEMS = 3

enum Count {
  One = 1,
  Two,
  Three,
  Four,
}

type Item = {
  id?: string
  image?: string
  title?: string
  body?: string
}

type Props = {
  entries: Array<Item>
}

const Jenga: React.FC<Props> = ({ entries }) => {
  const containers: Array<[string, Array<Item>]> = useMemo(() => {
    const items = entries.slice(0, MAX_ITEMS)

    switch (items.length) {
      default:
        return []
      case Count.One:
        return [
          ['top-left', [{ image: items[0].image }]],
          ['top-right', [{ title: items[0].title, body: items[0].body }]],
        ]
      case Count.Two:
        return [
          ['top-left', [items[0]]],
          ['top-right', [items[1]]],
        ]
      case Count.Three:
        return [
          ['top-left', [items[0]]],
          ['top-right', [items[1]]],
          ['bottom', [items[2]]],
        ]
      case Count.Four:
        return [
          ['top-left', [items[0], items[2]]],
          ['top-right', [items[1], items[3]]],
        ]
    }
  }, [entries])

  return (
    <div className={classNames(style.jenga)}>
      {containers.map(([name, container]) => (
        <div key={name} className={classNames(style.container, style[name])}>
          {container.map(({ id, image, title, body }) => (
            <Item
              key={id}
              className={classNames(style.item)}
              image={image}
              title={title}
              body={body}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default Jenga
